const React = require("react");

function LoadingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "none",
    strokeDasharray: "48,12",
    strokeDashoffset: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    fill: "remove",
    accumulate: "none",
    additive: "replace",
    attributeName: "transform",
    attributeType: "XML",
    calcMode: "linear",
    dur: "1s",
    from: "0 12 12",
    repeatCount: "indefinite",
    restart: "always",
    to: "360 12 12",
    type: "rotate"
  })));
}

module.exports = LoadingIcon;